import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import logo1 from "../../assets/images/logos/logo1.png";
import logo4 from "../../assets/images/logos/logo4.png";
import logo2 from "../../assets/images/logos/logo2.png";
import logo3 from "../../assets/images/logos/logo3.png";
import logo5 from "../../assets/images/logos/logo5.png";
import logo6 from "../../assets/images/logos/logo6.png";

import LeftGraphicsImage from "../../assets/images/LeftGraphics.png";
import RightGraphicsImage from "../../assets/images/RightGraphics.png";

const OurClients = () => {
  return (
    <Box
      sx={{
        width: "100%",
        position: "relative", // Ensure relative positioning for the graphics
        overflow: "hidden", // Ensure any overflow is hidden from the container itself
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: "6rem",
          position: "relative",
          paddingBottom: { xs: "0.2rem", sm: "6rem" },
        }}
      >
        {/* Right Graphics Image */}
        <Box
          sx={{
            position: "absolute",
            top: "25%",
            right: { xs: "-240%", sm: "-60%" },
            overflow: "hidden", // Overflow control on parent box
          }}
        >
          <Box
            component="img"
            src={RightGraphicsImage}
            alt="Right Graphics"
            sx={{
              width: { xs: "40%", sm: "60%" }, // Adjust the size to control overflow
              maxWidth: "none", // Prevent auto scaling
              position: "relative", // Position relative for overflow control
              transform: "translate(10%, -10%)", // Adjust positioning as needed
            }}
          />
        </Box>

        {/* Left Graphics Image */}
        <Box
          sx={{
            position: "absolute",
            top: "-25%",
            left: { xs: "-50%", sm: "-25%" },
            overflow: "hidden", // Overflow control for the left graphic too
          }}
        >
          <Box
            component="img"
            src={LeftGraphicsImage}
            alt="Left Graphics"
            sx={{
              width: "60%",
              maxWidth: "none",
              position: "relative",
            }}
          />
        </Box>

        {/* Clients Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "4rem",
            }}
          >
            <img src={Orangelogo} alt="Orange Logo" width="100%" />
          </Box>
          <Typography
            sx={{
              color: "rgba(35, 35, 37, 1)",
              fontFamily: "Montserrat",
              fontSize: { xs: "0.8rem", sm: "1rem" },
              marginTop: "0.8rem",
            }}
          >
            WHO WE HAVE WORKED WITH
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Montserrat",
              fontSize: { xs: "1.4rem", sm: "1.6rem" },
              fontWeight: "500",
              marginTop: "1.2rem",
            }}
          >
            Our <span style={{ color: "rgba(255, 102, 0, 1)" }}>Clients</span>
          </Typography>
        </Box>

        {/* Client Images */}
        <Box
          sx={{
            width: { xs: "20rem", sm: "62rem" },
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "center", sm: "space-between" },
            marginTop: "15px",
          }}
        >
          {[logo1, logo2, logo3, logo4, logo5, logo6].map((client, index) => (
            <Box key={index} sx={{ width: { xs: "4rem", sm: "6rem" } }}>
              <img src={client} alt={`Client ${index + 1}`} width="100%" />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default OurClients;
